export default {
    //各シーンの設定値
    default: {
        clipping_image: 'no_clip.png', //背景写真に合わせたクリッピング用画像
        rect_data: [
            {
                rect_position: { //初期設定の製品枠の座標
                    top_left:     {x: 340,  y: 70},
                    top_right:    {x: 696, y: 70},
                    bottom_left:  {x: 340, y: 318},
                    bottom_right: {x: 696, y: 318},
                },
                rect_width: 1810, //製品の大きさ（mm）
                rect_height: 1350,
            },
        ],
    },
    living_1: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 340,  y: 70},
                    top_right:    {x: 690, y: 70},
                    bottom_left:  {x: 340, y: 318},
                    bottom_right: {x: 690, y: 318},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    living_2: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 325,  y: 55},
                    top_right:    {x: 710, y: 55},
                    bottom_left:  {x: 325, y: 335},
                    bottom_right: {x: 710, y: 335},
                },
                rect_width: 1810,
                rect_height: 1350,
            },
        ],
    },
    living_3: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 566,  y: 36},
                    top_right:    {x: 760, y: 36},
                    bottom_left:  {x: 566, y: 330},
                    bottom_right: {x: 760, y: 330},
                },
                rect_width: 910,
                rect_height: 1450,
            },
            {
                rect_position: {
                    top_left:     {x: 280,  y: 36},
                    top_right:    {x: 474, y: 36},
                    bottom_left:  {x: 280, y: 330},
                    bottom_right: {x: 474, y: 330},
                },
                rect_width: 910,
                rect_height: 1450,
            },
        ],
    },
    living_4: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 309,  y: 104},
                    top_right:    {x: 584, y: 141},
                    bottom_left:  {x: 308, y: 231},
                    bottom_right: {x: 584, y: 250},
                },
                rect_width: 1790,
                rect_height: 690,
            },
        ],
    },
    'living_5-1': {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 82,  y: 126},
                    top_right:    {x: 434, y: 146},
                    bottom_left:  {x: 82, y: 530},
                    bottom_right: {x: 434, y: 508},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'living_5-2': {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 82,  y: 126},
                    top_right:    {x: 434, y: 146},
                    bottom_left:  {x: 82, y: 530},
                    bottom_right: {x: 434, y: 508},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'living_5-3': {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 82,  y: 126},
                    top_right:    {x: 434, y: 146},
                    bottom_left:  {x: 82, y: 530},
                    bottom_right: {x: 434, y: 508},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'living_5-4': {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 82,  y: 126},
                    top_right:    {x: 434, y: 146},
                    bottom_left:  {x: 82, y: 530},
                    bottom_right: {x: 434, y: 508},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'living_5-5': {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 82,  y: 126},
                    top_right:    {x: 434, y: 146},
                    bottom_left:  {x: 82, y: 530},
                    bottom_right: {x: 434, y: 508},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    living_6: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 82,  y: 126},
                    top_right:    {x: 434, y: 146},
                    bottom_left:  {x: 82, y: 530},
                    bottom_right: {x: 434, y: 508},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    living_7: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 82,  y: 126},
                    top_right:    {x: 434, y: 146},
                    bottom_left:  {x: 82, y: 530},
                    bottom_right: {x: 434, y: 508},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'bedroom_8-1': {
        clipping_image: 'bedroom_8_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 220,  y: 114},
                    top_right:    {x: 588, y: 140},
                    bottom_left:  {x: 220, y: 566},
                    bottom_right: {x: 588, y: 536},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'bedroom_8-2': {
        clipping_image: 'bedroom_8_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 220,  y: 114},
                    top_right:    {x: 588, y: 140},
                    bottom_left:  {x: 220, y: 566},
                    bottom_right: {x: 588, y: 536},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'bedroom_8-3': {
        clipping_image: 'bedroom_8_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 220,  y: 114},
                    top_right:    {x: 588, y: 140},
                    bottom_left:  {x: 220, y: 566},
                    bottom_right: {x: 588, y: 536},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'bedroom_8-4': {
        clipping_image: 'bedroom_8_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 220,  y: 114},
                    top_right:    {x: 588, y: 140},
                    bottom_left:  {x: 220, y: 566},
                    bottom_right: {x: 588, y: 536},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    'bedroom_8-5': {
        clipping_image: 'bedroom_8_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 220,  y: 114},
                    top_right:    {x: 588, y: 140},
                    bottom_left:  {x: 220, y: 566},
                    bottom_right: {x: 588, y: 536},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    bedroom_9: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 268,  y: 144},
                    top_right:    {x: 586, y: 144},
                    bottom_left:  {x: 268, y: 372},
                    bottom_right: {x: 586, y: 372},
                },
                rect_width: 1810,
                rect_height: 1250,
            },
        ],
    },
    bedroom_10: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 341,  y: 110},
                    top_right:    {x: 663, y: 110},
                    bottom_left:  {x: 341, y: 232},
                    bottom_right: {x: 663, y: 232},
                },
                rect_width: 1790,
                rect_height: 690,
            },
        ],
    },
    kidroom_11: {
        clipping_image: 'kidroom_11_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 86,  y: 44},
                    top_right:    {x: 440, y: 58},
                    bottom_left:  {x: 86, y: 352},
                    bottom_right: {x: 440, y: 352},
                },
                rect_width: 1410,
                rect_height: 1250,
            },
        ],
    },
    kidroom_12: {
        clipping_image: 'kidroom_12_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 560,  y: 56},
                    top_right:    {x: 920, y: 46},
                    bottom_left:  {x: 560, y: 352},
                    bottom_right: {x: 920, y: 352},
                },
                rect_width: 1410,
                rect_height: 1250,
            },
        ],
    },
    workspace_13: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 490,  y: 92},
                    top_right:    {x: 888, y: 10},
                    bottom_left:  {x: 490, y: 560},
                    bottom_right: {x: 890, y: 674},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
            {
                rect_position: {
                    top_left:     {x: 216,  y: 108},
                    top_right:    {x: 330, y: 120},
                    bottom_left:  {x: 216, y: 374},
                    bottom_right: {x: 330, y: 370},
                },
                rect_width: 710,
                rect_height: 1350,
            },
        ],
    },
    workspace_14: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 394,  y: 46},
                    top_right:    {x: 726, y: 46},
                    bottom_left:  {x: 394, y: 330},
                    bottom_right: {x: 726, y: 330},
                },
                rect_width: 1410,
                rect_height: 1250,
            },
        ],
    },
    jp_15: {
        clipping_image: 'jp_15_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 80,  y: 96},
                    top_right:    {x: 404, y: 106},
                    bottom_left:  {x: 80, y: 468},
                    bottom_right: {x: 404, y: 452},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    jp_16: {
        clipping_image: 'jp_16_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 323,  y: 80},
                    top_right:    {x: 448, y: 93},
                    bottom_left:  {x: 326, y: 450},
                    bottom_right: {x: 446, y: 438},
                },
                rect_width: 790,
                rect_height: 1990,
            },
            {
                rect_position: {
                    top_left:     {x: 102,  y: 54},
                    top_right:    {x: 260, y: 72},
                    bottom_left:  {x: 105, y: 476},
                    bottom_right: {x: 258, y: 460},
                },
                rect_width: 790,
                rect_height: 1990,
            },
        ],
    },
    jp_17: {
        clipping_image: 'jp_17_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 74,  y: 337},
                    top_right:    {x: 418, y: 327},
                    bottom_left:  {x: 75, y: 476},
                    bottom_right: {x: 416, y: 442},
                },
                rect_width: 1790,
                rect_height: 690,
            },
        ],
    },
    kitchen_18: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 202,  y: 50},
                    top_right:    {x: 606, y: 110},
                    bottom_left:  {x: 202, y: 614},
                    bottom_right: {x: 606, y: 556},
                },
                rect_width: 1910,
                rect_height: 2050,
            },
        ],
    },
    kitchen_19: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 336,  y: 221},
                    top_right:    {x: 650, y: 221},
                    bottom_left:  {x: 336, y: 367},
                    bottom_right: {x: 650, y: 367},
                },
                rect_width: 990,
                rect_height: 490,
            },
        ],
    },
    kitchen_20: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 320,  y: 84},
                    top_right:    {x: 464, y: 90},
                    bottom_left:  {x: 320, y: 350},
                    bottom_right: {x: 464, y: 344},
                },
                rect_width: 710,
                rect_height: 1350,
            },
        ],
    },
    sanitary_21: {
        clipping_image: 'no_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 460,  y: 68},
                    top_right:    {x: 638, y: 68},
                    bottom_left:  {x: 460, y: 410},
                    bottom_right: {x: 638, y: 410},
                },
                rect_width: 590,
                rect_height: 1190,
            },
        ],
    },
    sanitary_22: {
        clipping_image: 'sanitary_22_clip.png',
        rect_data: [
            {
                rect_position: {
                    top_left:     {x: 492,  y: 56},
                    top_right:    {x: 830, y: 32},
                    bottom_left:  {x: 492, y: 326},
                    bottom_right: {x: 830, y: 330},
                },
                rect_width: 1410,
                rect_height: 1250,
            },
        ],
    },
}
